import { CommonModule } from '@angular/common';
import {
  Component,
  effect,
  input,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { combineLatest, map, tap } from 'rxjs';
import { MenuCollapseItemComponent } from '../menu-collapse-item/menu-collapse-item.component';
import { HoveredLeftMenuDirective } from '../../directives/hoveredLeftMenu.directive';
import { NavigationItem } from '../../interfaces/navigationList.interface';
import { PageContainerService } from '../../services/page-container.service';

@Component({
  selector: 'st-icon-button',
  standalone: true,
  imports: [
    CommonModule,
    TooltipModule,
    HoveredLeftMenuDirective,
    MenuCollapseItemComponent,
    RouterModule,
  ],
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class IconButtonComponent {
  navigationItem = input.required<NavigationItem>();

  isActive = signal(false);
  canHover = signal(false);
  menuOptions: any = {
    autoClose: false,
    menuWidth: '260px',
  };

  menuExpanded$ = this.pageContainerService.menuExpanded;
  activeSectionRoute$ = this.pageContainerService.activeSectionRoute;

  activeChild!: NavigationItem | null;

  combineExpandedActiveSection$ = combineLatest([
    this.activeSectionRoute$,
    this.menuExpanded$,
  ]).pipe(
    tap(([x, menuExpanded]) => {
      const currentNavItem = this.navigationItem();
      const currentUrl = this.router.url;
      const isDispatchUrl = currentUrl.includes('dispatch');

      if (x && x.id === this.navigationItem()?.id) {
        this.getRoutePath(x);
        if (menuExpanded) {
          this.canHover.set(false);
        } else {
          this.canHover.set(this.navigationItem().children.length > 0);
        }
        this.isActive.set(true);
      } else {
        this.canHover.set(this.navigationItem().children.length > 0);
        this.isActive.set(false);
        this.activeChild = null;
      }
      if (isDispatchUrl && currentNavItem.id === 1) {
        this.isActive.set(true);
        const activeRidesChild = currentNavItem.children.find(
          child => child.id === 6,
        );
        this.activeChild = activeRidesChild || null;
      }
    }),
    map(([x, menuExpanded]) => x),
  );

  constructor(
    readonly pageContainerService: PageContainerService,
    readonly router: Router,
  ) {
    effect(() => {
      this.canHover.update(x => {
        return this.navigationItem().children.length > 0;
      });
    });
  }

  onClick() {
    this.pageContainerService.activeSectionRoute.next(this.navigationItem());
  }

  getRoutePath(item: NavigationItem | null) {
    if (item) {
      const currentUrl = this.router.url;

      if (item.id === 1 && currentUrl.includes('/dispatch')) {
        this.activeChild = item.children.find(child => child.id === 6) || null;
        return;
      }

      let currentPath = this.pageContainerService
        .getRoutePath()
        .find(x => x.url === currentUrl)?.routePath;

      const index = this.navigationItem().children.findIndex(
        y => y && currentPath && y.id === currentPath[1],
      );

      if (index !== -1) {
        this.activeChild = this.navigationItem().children[index];
      } else {
        this.activeChild = null;
      }
    }
  }
}
